var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FillClaimTableUser',{attrs:{"countFilterParams":_vm.countFilterParams,"filterGetParams":_vm.filterGetParams,"createData":_vm.createData},on:{"resetFilter":_vm.resetFilter,"showMore":_vm.showMore,"changeFilter":_vm.changeFilter,"reload":_vm.reload,"downloadFiles":_vm.downloadFiles}})
}
var staticRenderFns = []

export { render, staticRenderFns }